<nav
  class="navbar bg-primary navbar-expand-lg d-none d-lg-flex shadow px-3"
  [ngClass]="{
    'kids-navbar border-0': isKid
  }"
>
  <a
    [ngClass]="{
      'kids-logo': isKid
    }"
    class="navbar-brand py-0"
    [routerLink]="['/']"
    routerLinkActive="router-link-active"
    attr.aria-label="{{ 'nav.home.page.screenreader' | translate : { fgbdefault: 'Move to home page' } }}"
  >
    <label id="homeLink" class="accessibility-only">Go To Home Page</label>
    <img
      alt=""
      [ngClass]="{
        'kids-logo': isKid
      }"
      class="ms-1 nav-logo"
      aria-labelledby="homeLink"
      src="assets/images/logo.png"
      draggable="false"
    />
  </a>

  <button
    class="navbar-toggler"
    type="button"
    (click)="isCollapsed = !isCollapsed"
    aria-controls="navbarSupportedContent"
    aria-expanded="false"
    attr.aria-label="{{ 'nav.toggle.screenreader' | translate }}"
  >
    <span class="navbar-toggler-icon"></span>
  </button>

  <!-- Middle Club Links -->
  <div class="nav-middle w-100">
    <ng-container *inPopulation="[populations.Default, populations.Club1901]">
      <div class="navbar-collapse" [ngbCollapse]="isCollapsed" id="navbarSupportedContent">
        <div class="nav-container justify-content-center">
          <ul class="navbar-nav justify-content-center club-links" #greedyNav>
            <li class="nav-item">
              <a
                href="{{ 'nav.club.link.url' | translate }}"
                target="_blank"
                class="nav-link"
                attr.aria-label="{{ 'nav.rewards.screenreader' | translate : { fgbdefault: 'Move to rewards page' } }}"
                >{{ 'nav.club.link' | translate }}</a
              >
            </li>

            <li class="nav-item">
              <a
                href="{{ 'nav.tickets.link.url' | translate }}"
                target="_blank"
                class="nav-link"
                attr.aria-label="{{ 'nav.payment.screenreader' | translate : { fgbdefault: 'Move to challenges page' } }}"
                >{{ 'nav.tickets.link' | translate }}</a
              >
            </li>

            <li class="nav-item">
              <a
                href="{{ 'nav.shop.link.url' | translate }}"
                target="_blank"
                class="nav-link"
                attr.aria-label="{{ 'nav.payment.screenreader' | translate : { fgbdefault: 'Move to payment page' } }}"
                >{{ 'nav.shop.link' | translate }}</a
              >
            </li>
          </ul>
        </div>
      </div>

      <hr class="middle-line" />
    </ng-container>
    <div class="navbar-collapse kid" [ngbCollapse]="isCollapsed" id="navbarSupportedContent">
      <div class="nav-container">
        <ul class="navbar-nav" #greedyNav>
          <li class="nav-item">
            <a
              [ngClass]="{
                'text-white': isKid
              }"
              class="nav-link"
              [routerLink]="['/challenges']"
              routerLinkActive="router-link-active"
              attr.aria-label="{{ 'nav.payment.screenreader' | translate : { fgbdefault: 'Move to challenges page' } }}"
              >{{ 'nav.challenges' | translate }}</a
            >
          </li>

          <li class="nav-item">
            <a
              [ngClass]="{
                'text-white': isKid
              }"
              class="nav-link"
              [routerLink]="['/rewards']"
              routerLinkActive="router-link-active"
              attr.aria-label="{{ 'nav.rewards.screenreader' | translate : { fgbdefault: 'Move to rewards page' } }}"
              >{{ 'nav.rewards' | translate }}</a
            >
          </li>

          <li class="nav-item">
            <a
              [ngClass]="{
                'text-white': isKid
              }"
              class="nav-link"
              [routerLink]="['/games']"
              routerLinkActive="router-link-active"
              attr.aria-label="{{ 'nav.games.screenreader' | translate : { fgbdefault: 'Move to games page' } }}"
              >{{ 'nav.games' | translate }}</a
            >
          </li>

          <li class="nav-item">
            <a
              [ngClass]="{
                'text-white': isKid
              }"
              class="nav-link"
              [routerLink]="['/tv']"
              routerLinkActive="router-link-active"
              attr.aria-label="{{ 'nav.gallery.screenreader' | translate : { fgbdefault: 'Move to gallery page' } }}"
              >{{ 'nav.gallery' | translate }}</a
            >
          </li>

          <ng-container *inPopulation="populations.Kids">
            <li class="nav-item">
              <a
                class="nav-link text-white"
                [routerLink]="['/training-zone']"
                routerLinkActive="router-link-active"
                attr.aria-label="{{
                  'nav.training.zone.screenreader' | translate : { fgbdefault: 'Move to training-zone page' }
                }}"
                >{{ 'nav.training.zone' | translate }}</a
              >
            </li>
          </ng-container>

          <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.offers'">
            <ng-container *inPopulation="[populations.Default, populations.Club1901]">
              <li class="nav-item">
                <a
                  class="nav-link"
                  [routerLink]="['/offers']"
                  routerLinkActive="router-link-active"
                  attr.aria-label="{{ 'nav.offers.screenreader' | translate : { fgbdefault: 'Move to offers page' } }}"
                  >{{ 'nav.offers' | translate }}</a
                >
              </li>
            </ng-container>
          </ng-container>
        </ul>
      </div>
      <!-- Right Side Content -->
      <div class="d-flex align-items-center flex-nowrap my-2 my-lg-0 right-side-nav">
        <!-- Help Dropdown -->
        <div class="nav-item active help-dropdown static-nav-item" #helpBtn>
          <div ngbDropdown #ddHelp="ngbDropdown" [autoClose]="'outside'" role="group">
            <a
              [ngClass]="{
                'text-white': isKid
              }"
              class="nav-link mx-1"
              id="helpdropdown"
              ngbDropdownToggle
              attr.aria-label="{{ 'nav.help.screenreader' | translate : { fgbdefault: 'Click for help pages' } }}"
            >
              <span>{{ 'nav.help' | translate }}</span>
            </a>
            <ul ngbDropdownMenu (click)="closeDropDown(ddHelp)" aria-labelledby="helpdropdown" class="p-2 pe-lg-5">
              <li class="nav-item active">
                <a
                  class="nav-link ms-2 fw-normal"
                  href="{{ 'nav.faqs.url' | translate }}"
                  target="_blank"
                  routerLinkActive="router-link-active"
                  attr.aria-label="{{ 'nav.faq.screenreader' | translate : { fgbdefault: 'Move to faq page' } }}"
                  >{{ 'nav.faq' | translate }}</a
                >
              </li>
              <li class="nav-item active">
                <a
                  href="{{ 'nav.contact.us.url' | translate }}"
                  target="_blank"
                  class="nav-link ms-2 fw-normal"
                  attr.aria-label="{{ 'nav.contact.us.screenreader' | translate : { fgbdefault: 'Move to contact us page' } }}"
                  >{{ 'nav.contact.us' | translate }}</a
                >
              </li>
              <li class="nav-item active">
                <a
                  href="{{ 'nav.terms.url' | translate }}"
                  target="_blank"
                  class="nav-link ms-2 fw-normal"
                  attr.aria-label="{{ 'nav.terms.screenreader' | translate : { fgbdefault: 'Move to terms page' } }}"
                  >{{ 'nav.terms' | translate }}</a
                >
              </li>
            </ul>
          </div>
        </div>

        <!--Notifications-->
        <fgb-notification-button></fgb-notification-button>

        <!--Divider-->
        <div
          [ngClass]="{
            'bg-white': isKid
          }"
          class="nav-divider-line"
        ></div>

        <!--Account Info-->
        <div
          [ngClass]="{
            'rounded p-2': isKid
          }"
          class="member"
          ngbDropdown
          #ddAccount="ngbDropdown"
          [autoClose]="'outside'"
          focusTab
        >
          <button
            class="nav-link text-white btn d-flex align-items-center mx-2 px-0 justify-content-end"
            id="namedropdown"
            ngbDropdownToggle
            attr.aria-label="{{
              'nav.account.dropdown.screenreader' | translate : { fgbdefault: 'Click for more account menu' }
            }}"
            tabindex="-1"
          >
            <div *ngIf="memberDetails$ | async as memberDetails; else memberDetailsLoading" class="user-box h-100 d-inline-block">
              <div class="font-size-14 text-start fw-bold">{{ memberDetails!.FirstName }} {{ memberDetails!.Surname }}</div>
            </div>
          </button>

          <div
            ngbDropdownMenu
            (click)="closeDropDown(ddAccount)"
            aria-labelledby="namedropdown"
            class="shadow text-center border-0 dropdown-menu p-0 account-dropdown mt-2"
          >
            <div class="text-info">
              <a
                class="d-flex align-items-center account-btn text-black bg-white py-0 px-2 font-size-14 nav-item-fixed-height rounded-top"
                ngbDropdownItem
              >
                <span class="icon material-icons material-dropdown-icon me-2" aria-hidden="true">person</span>
                <div class="dropdown-link text-start">
                  <div class="mt-2 fw-bold">{{ 'nav.dropdown.account' | translate }}</div>
                  <div class="nav-bar-little-text text-start" *ngIf="card$ | async as memberCard">
                    {{ 'nav.dropdown.account.number' | translate }} {{ memberCard.ExternalRefNumber }}
                  </div>
                </div>
              </a>
            </div>

            <hr class="text-disabled w-90 mx-auto my-0" />

            <div class="text-black">
              <a
                [routerLink]="['/rewards/wallet']"
                routerLinkActive="router-link-active"
                attr.aria-label="{{ 'nav.wallet.screenreader' | translate : { fgbdefault: 'Move to wallet page' } }}"
                class="d-flex align-items-center account-btn text-black bg-white py-0 px-2 nav-item-fixed-height"
                ngbDropdownItem
              >
                <span class="icon material-icons material-dropdown-icon me-2" aria-hidden="true">account_balance_wallet</span>
                <div class="dropdown-link text-start">
                  <div class="font-size-14 fw-bold">{{ 'nav.wallet' | translate }}</div>
                </div>
              </a>
              <hr class="text-disabled w-90 mx-auto my-0" />
            </div>

            <div
              [ngClass]="{
                'd-none': isKid
              }"
              class="text-black"
            >
              <a
                href="{{ 'nav.benefits.url' | translate }}"
                target="_blank"
                attr.aria-label="{{ 'nav.benefits.screenreader' | translate : { fgbdefault: 'Move to benefits' } }}"
                class="d-flex align-items-center account-btn text-black bg-white py-0 px-2 nav-item-fixed-height"
                ngbDropdownItem
              >
                <span class="icon material-icons material-dropdown-icon me-2" aria-hidden="true">loyalty</span>
                <div class="dropdown-link text-start">
                  <div class="font-size-14 fw-bold">{{ 'nav.benefits' | translate }}</div>
                </div>
              </a>
              <hr class="text-disabled w-90 mx-auto my-0" />
            </div>

            <div>
              <button
                class="logout-btn d-flex align-items-center bg-white px-2 nav-item-fixed-height rounded-bottom"
                (click)="logout()"
                ngbDropdownItem
                attr.aria-label="{{ 'nav.log.out.screenreader' | translate : { fgbdefault: 'Log out' } }}"
              >
                <span class="icon material-icons material-dropdown-icon me-2 text-danger" aria-hidden="true"
                  >power_settings_new</span
                >
                <div class="dropdown-link text-start">
                  <div class="text-danger font-size-14 fw-bold" ngbDropdownItem (click)="logout()">
                    {{ 'nav.log.out' | translate : { fgbdefault: 'Log out' } }}
                  </div>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</nav>

<ng-template #memberDetailsLoading>
  <div class="user-box d-block text-center text-on-primary px-4">
    <fgbcl-loading [size]="'small'"></fgbcl-loading>
  </div>
</ng-template>
